export default __webpack_public_path__ + "locales/pt/PaymentsEnterprise.json?hash=9e6460c2356cbb9332ee829d269850bf";